// extracted by mini-css-extract-plugin
export default {"container":"AAUVFk3tBqQwknsXBLe7","hover":"VrmMdznvFggDtRZwteMs","text":"Xh62dPg8CaQyMIqoSbiQ","fadeIn":"OF07YoYOhxkOsYEd1n43"};